import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__brand">
          <span className="footer__logo honk-title">Champions Collective</span>
          <p className="footer__tagline chiron-goround-tc-light">
            Participez à des tournois organisés par la communauté
          </p>
        </div>

        <nav className="footer__nav">
          <ul className="footer__links">
            <li>
              <Link to="/" className="footer__link staatliches-regular">Accueil</Link>
            </li>
            <li>
              <Link to="/a-propos" className="footer__link staatliches-regular">À propos</Link>
            </li>
            <li>
              <Link to="/tournois" className="footer__link staatliches-regular">Tournois</Link>
            </li>
            <li>
              <Link to="/classement" className="footer__link staatliches-regular">Classement</Link>
            </li>
            <li>
              <Link to="/statistiques" className="footer__link staatliches-regular">Statistiques</Link>
            </li>
            <li>
              <Link to="/palmares" className="footer__link staatliches-regular">Palmarès</Link>
            </li>
            <li>
              <a
                href="https://discord.gg/8PtsyHNPru"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link staatliches-regular"
              >
                Discord
              </a>
            </li>
          </ul>
        </nav>

        <div className="footer__bottom">
          <p className="chiron-goround-tc-light">
            &copy; {new Date().getFullYear()} Champions Collective. Données fournies par Limitless.
          </p>
        </div>
      </div>
    </footer>
  );
}
